<template lang="pug">
    .form-heading-wrapper(
        :class='{short: short, feedback: feedback}',
    )
        .h1.form-heading-wrapper__title(
            v-html='title'
        )

        .form-heading-wrapper__subtitle(
            v-if='hasSubtitle',
            v-html='subtitle'
        )

        slot
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'FormHeadingWrapper',
    props: {
        title: {
            type: String,
            require: true
        },
        subtitle: {
            type: [String, undefined]
        },
        short: {
            type: Boolean
        },
        feedback: {
            type: Boolean
        }
    },
    computed: {
        hasSubtitle() {
            return !!this.subtitle;
        }
    }
});
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';

.form-heading-wrapper {
    color: var(--color-accent-text);

    &.short,
    &.feedback {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &.feedback {
        color: var(--color-main-text);
    }

    @media (--viewport-tablet) {
        padding: 2em calc(var(--layout-column-width) + var(--layout-gutter-width)) 3em;
    }

    &__title {
        margin: 0 auto 0.73em;
        text-align: center;

        @media (--viewport-tablet) {
            margin-bottom: 0.5em;
            text-align: left;
        }
    }

    &__subtitle {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto 4.4em;
        text-align: center;

        @media (--viewport-tablet) {
            width: 100%;
            margin-bottom: 1em;
        }
    }
}
</style>
